export const EDITOR_DRAFT_EXPIRATION_DELTA = 1000 * 3600 * 24; // 1 day

//# sourceMappingURL=constants.js.map